<template>
  <CHeader fixed with-subheader light>
    <CToggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
    <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
    <CHeaderNav class="mr-4 ml-auto">
      <div class="row" style="display: flex; justify-content:center; align-items: center;">
        <TheAdminHeaderDropdown />
        <div style="font-size: 16px; margin:0 10px">{{userDisplayname}}</div>
      </div>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheAdminHeaderDropdown from "./TheAdminHeaderDropdown";
import "../../assets/scss/_adminStyle.scss";
import { mapGetters } from "vuex";

export default {
  name: "TheAdminHeader",
  components: {
    TheAdminHeaderDropdown,
  },
  data() {
    return {
      userDisplayname: "Display Name",
    };
  },
  computed: {
    ...mapGetters({
      getUserinfo: "necessary/getUserinfo",
    }),
  },
  watch: {
    getUserinfo: function (val) {
      this.userDisplayname = val.displayname;
    },
  },
  created() {
    if (this.$store.getters["necessary/getUserinfo"].length !== 0) {
      this.userDisplayname = this.$store.getters[
        "necessary/getUserinfo"
      ].displayname;
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
